// extracted by mini-css-extract-plugin
export default {"signature-field":"styles__signature-field--n4upw","input-wrapper":"styles__input-wrapper--r5nCh","underline":"styles__underline--uUjsi","x-icon":"styles__x-icon--O+0h9"};